import { render, staticRenderFns } from "./suggestionFirstAudit.vue?vue&type=template&id=34acd571"
import script from "./suggestionFirstAudit.vue?vue&type=script&lang=js"
export * from "./suggestionFirstAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34acd571')) {
      api.createRecord('34acd571', component.options)
    } else {
      api.reload('34acd571', component.options)
    }
    module.hot.accept("./suggestionFirstAudit.vue?vue&type=template&id=34acd571", function () {
      api.rerender('34acd571', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sug/suggestionFirstAudit.vue"
export default component.exports